import { IAbstractInitialState } from "../../types/common";
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { getRizdvonikiUsers } from "../../api/asyncThuncks/rizdvoniki";

interface IInitialState extends IAbstractInitialState {
  rizdvoniki: any;
}

const initialState: IInitialState = {
  loading: "idle",
  rizdvoniki: [],
  error: "",
};

const rizdvoniki = createSlice({
  name: "rizdvoniki",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // .addCase(getRizdvoniki.pending, (state) => {
      //   state.loading = "pending";
      // })
      // .addCase(getRizdvoniki.fulfilled, (state, { payload }) => {
      //   state.rizdvoniki = payload;
      //   state.loading = "idle";
      // })
      // .addCase(getRizdvoniki.rejected, (state, { error }) => {
      //   if (error.message) state.error = error.message;
      //   state.loading = "failed";
      // })
      .addCase(getRizdvonikiUsers.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(getRizdvonikiUsers.fulfilled, (state, { payload }) => {
        state.rizdvoniki = [...payload];
        state.loading = "idle";
      })
      .addCase(getRizdvonikiUsers.rejected, (state, { error }) => {
        if (error.message) state.error = error.message;
        state.loading = "failed";
      });
  },
});

export const selectRizdvoniki = (state: RootState): IInitialState =>
  state.rizdvoniki;

export default rizdvoniki.reducer;
